import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "../App";
import axios from "axios";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setGoogleUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error("No session_id found in URL");
          navigate("/auth");
          return;
        }

        const sessionId = sessionIdMatch[1];
        const userType = localStorage.getItem("pending_user_type") || "creator";

        // Exchange session_id for user data
        const response = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId, user_type: userType },
          { withCredentials: true }
        );

        const { user } = response.data;
        
        // Store session and update auth state
        setGoogleUser(user);
        
        // Clean up
        localStorage.removeItem("pending_user_type");

        // Redirect based on user type
        if (user.user_type === "business") {
          navigate("/dashboard", { replace: true, state: { user } });
        } else if (user.user_type === "creator") {
          navigate("/creator", { replace: true, state: { user } });
        } else if (user.user_type === "admin") {
          navigate("/admin", { replace: true, state: { user } });
        } else {
          navigate("/", { replace: true });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/auth");
      }
    };

    processAuth();
  }, [navigate, setGoogleUser]);

  return (
    <div className="min-h-screen bg-[#05060D] flex items-center justify-center">
      <div className="text-center">
        <div className="spinner mx-auto mb-4"></div>
        <p className="text-gray-400">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
